/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_14234ad1"]'><div :class='["checkbox-group-slot-demo"]'><div :class='["cube-checkbox-group-example"]'><cube-checkbox-group :values="checkedValues" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValues", "__mpx_event__", ["value"], undefined]])' @checked='(e)=>__invoke(e, [["onChecked"]])' @cancelChecked='(e)=>__invoke(e, [["onCancelChecked"]])'><cube-checkbox v-for="(option, index) in (options)" :key="option.index" :option="(option)"></cube-checkbox></cube-checkbox-group></div><div :class='["view-desc"]'>选中 value 值：{{ checkedValues }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_14234ad1"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_14234ad1"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_14234ad1"}
  /** script content **/
  require("./group-slot.mpx.js?isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./group-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fgroup-slot14234ad1%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_14234ad1"],
    ctorType: "component",
    outputPath: "components/group-slot14234ad1/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>